<template>
  <div class="col-inner p-3 bg-white rounded">
    <fix-price-control-panel-component
      :lot="prop_lot"
      :reserve_time="reservation_hours"
      v-if="!sold"
      @sold="sold=true"
    />
    <div class="row" v-else>
      <div class="col text-center">{{ trans('lots.sold') }}</div>
    </div>
    <div class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|}  button-group-3 mt-5 mx-0 gap-2">
      <div class="col-12 align-self-center px-0">
        <question-component :lot_id="lot.id"/>
      </div>
    </div>
  </div>
  <!-- Reports -->
  <div class="mt-3 data-report px-lg-5 py-lg-2">
    <template
      v-if="!!lot.car.reports"
      v-for="report in reports"
    >
      <div
        v-if="!!lot.car[report.erp]"
        class="row ${1| ,row-cols-2,row-cols-3, auto,justify-content-md-center,|} mb-2"
      >
        <div class="col-6  align-self-center">
          <h5 class="m-0 fw-bold-600 back-text">{{ report.header }}</h5>
        </div>
        <div class="col-6 ">
          <a
            role="button"
            target="_blank"
            :href="lot.car[report.erp]"
            class="px-10-py-5 extra-rounded text-center btn-primary dark-bg d-block text-decoration-none"
          >{{ report.button }}</a>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import QuestionComponent from "../QuestionComponent.vue";
import FixPriceControlPanelComponent from "./fixprice/FixPriceControlPanelComponent.vue";

export default {
  name: 'FixPriceLotFullComponent',
  components: {QuestionComponent, FixPriceControlPanelComponent},
  created() {
    this.lot = this.prop_lot
    this.sold = !!this.lot.max_rate_client_user_id
  },
  props: [
    'prop_lot',
    'reservation_hours',
  ],
  data() {
    return {
      lot: undefined,
      sold: false,
      reports: [
        {
          erp: 'tech_report_link',
          header: 'Tilstandsrapport',
          button: 'Vis rapport',
        },
        {
          erp: 'short_report_link',
          header: 'Tilstandsrapport',
          button: 'Vis rapport',
        },
        {
          erp: 'annet_report_link',
          header: 'Annet',
          button: 'Vis info',
        },
        {
          erp: 'equipment_report_link',
          header: 'Utstyrsliste',
          button: 'Vis info',
        },
        {
          erp: 'garage_history_report_link',
          header: 'Verkstedhistorikk',
          button: 'Vis info',
        }
      ],
    }
  },
}
</script>

<style scoped>
</style>
